<!-- 
  ## Table
  - Created with CSS Grid instead of <table> for responsve behaviour
-->
@if(!tableContext.isTableInitialized()){
<app-table-loading-skeleton />
} @else{

<app-table-header />

@if(!tableContext.hasChartView() || tableContext.viewType() === 'table'){
  @if(tableContext.isError()){
<div class="error-wrapper" [class.is-loading]="tableContext.isLoading()">
  <div class="error-box">
    <button (click)="refresh()">
      <ng-icon name="refreshDouble" size="52"></ng-icon>
    </button>
    <p>{{ dictionaryService.get('ErrorOccured') }}</p>
  </div>

  <div class="spinner-wrapper">
    <app-loading-spinner />
  </div>
</div>

}
@else if (!tableContext.tableData().rows.length){
<div class="no-data">
  <ng-icon name="reports" size="64"></ng-icon>
  <p>{{ dictionaryService.get('NoDataFound') }}</p>
</div>
}@else {
<div class="table-wrapper" [class.is-loading]="tableContext.isLoading()">
  <div
    class="table"
    [class.copy-disabled]="!tableContext.canCopy()"
    (copy)="handleCopy($event)"
    [ngStyle]="{
      '--cols-count': tableCount,
      '--columns': tableContext.tableFormatService.columnDistribution,
      '--table-row-height': tableContext.rowHeight() + 'px'
    }"
  >
    <!-- Table Head -->
    <app-head-row>
      <input
        type="checkbox"
        [checked]="isAllSelected()"
        (change)="handleSelectAll($event)"
        (click)="$event.stopPropagation()"
      />
    </app-head-row>

    <!-- Table Body -->
    @if(tableContext.groupCells()){

    <app-adhock-table />

    }@else {

    <div class="body">
      @for(row of tableContext.tableData().rows; let rowIndex = $index; track
      row.id){
      <div
        class="row"
        [ngClass]="{
          clickable: tableContext.onRowClick()? true : false,
          selected: row.selected,
          'row-deleted': tableContext.DeletedRowsStyle() && row.value['isDeleted'],
        }"
        (click)="tableContext.onRowClick()?.(row)"
      >
        @if (tableContext.canSelect()) {
        <div
          class="col"
          style="
            width: 40px;
            min-width: 40px;
            max-width: 40px;
            text-align: center;
          "
        >
          <input
            type="checkbox"
            [checked]="row.selected"
            (change)="tableContext.handleRowChecked(rowIndex, $event)"
            (click)="$event.stopPropagation()"
          />
        </div>
        } @if(tableContext.hasIndexCol()){
        <div class="col" style="width: 80px; text-align: center">
          {{ rowIndex + 1 + (tableContext.page() - 1) * tableContext.pageSize }}
        </div>
        } @for (col of tableContext.tableData().heads; let colIndex = $index;
        track col.name) { @if(!col.ignore){

        <div
          class="col"
          [attr.type]="'individual'"
          [attr.title]="
            col.type === 'group' ||
            col.dataType === 'link' ||
            tableContext.getCustomCell(col.name)
              ? null
              : row.value[col.name]
          "
        >
          @if (col.type !== 'button'){
          <div>
            @let customCell = tableContext.getCustomCell(col.name);
            @if (customCell) {
            <ng-container
              *ngTemplateOutlet="
                customCell.template;
                context: createCellCtx(row.value[col.name], row, col)
              "
            ></ng-container>
            } @else if (col.type === 'single' && col.dataType === 'link') {
            <div class="link-cell">
              @for (attachment of tableContext.getAttachmentValues(row.value[col.name]); track attachment) {
              <div class="link-entry">
                <span class="link-name" [title]="tableContext.getAttachmentName(attachment)">
                  {{ tableContext.getAttachmentName(attachment) }}
                </span>
                <span class="link-actions">
                  <a
                    class="link-action"
                    [href]="tableContext.resolveAttachmentUrl(attachment)"
                    target="_blank"
                    rel="noopener noreferrer"
                    [title]="'Preview ' + tableContext.getAttachmentName(attachment)"
                    (click)="$event.stopPropagation()"
                  >
                    <ng-icon name="OpenInWindow" size="20"></ng-icon>
                  </a>
                </span>
              </div>
              }
            </div>
            } @else if (col.type === 'single'){ @if( col.dataType === 'numeric' &&
            tableContext.coloring()?.columns?.includes(col.name) ) {
            <p
              class="cell"
              [ngStyle]="{
                color: tableContext.coloring()?.colorFn(+row.value[col.name])
              }"
            >
              {{ row.value[col.name] }}
            </p>

            }@else {
            <p class="cell">
              {{ row.value[col.name] }}
            </p>
            } } @else if (col.type === 'index'){
            <p class="cell">
              {{
                rowIndex + 1 + tableContext.pageSize * (tableContext.page() - 1)
              }}
            </p>
            } @else if (col.type === 'group') {
            <app-group-cols [col]="col" [rowIndex]="rowIndex" />
            }
          </div>
          }
        </div>
        } } @for(col of tableContext.actionCol(); let actionIndex = $index;
        track actionIndex) {
        <div class="col" [attr.type]="'individual'">
          <ng-container
            *ngTemplateOutlet="
              col.actionButton;
              context: createCtx(row, actionIndex)
            "
          ></ng-container>
        </div>
        }
      </div>

      }
    </div>
    }
  </div>
  <div class="spinner-wrapper">
    <app-loading-spinner />
  </div>
  <app-table-footer />
</div>
} } @if( tableContext.hasChartView() && tableContext.viewType() === 'chart') {
<div class="bar-chart">
  @if(tableContext.isLoading()){
  <div class="loading-overlay"></div>
  <div class="spinner-overlay">
    <app-loading-spinner />
  </div>
  }
  <app-bar-chart
    [name]="tableContext.name()"
    [title]="tableContext.name()"
    class="chart-canvas"
    [class.visible]="!tableContext.isLoading()"
  ></app-bar-chart>
</div>
} }
